<mat-checkbox class="example-margin"
              [checked]="checked"
              (change)="checked = ($event.checked)"
              [disabled]="disabled">
</mat-checkbox>
<span [class.text-decoration-line-through]="checked && strikeWhenComplete" (click)="textClickEvent.emit()">{{label}}</span>
